import { IColumn, Link, MessageBar, ShimmeredDetailsList } from '@fluentui/react';
import { VisitSummary } from '../../api';
import { ROUTES } from '../../config/routes';
import { CollapsibleSection } from '../visit/CollapsibleSection';
import { VisitStatusIcon } from '../visit/VisitStatusIcon';

export function PatientVisits({ visits, title = 'Visits' }: { visits: VisitSummary[]; title?: string }) {
  const columns: IColumn[] = [
    {
      key: 'Date',
      name: 'Date',
      minWidth: 90,
      maxWidth: 90,
      onRender: (item: VisitSummary) => item.timeSlot?.longDateString,
    },
    {
      key: 'Visit Code',
      name: 'Visit Code',
      minWidth: 90,
      maxWidth: 90,
      onRender: (item: VisitSummary) => (
        <Link href={`${ROUTES.visits}/${item.visitCode}`} target="_blank">
          {item.visitCode}
        </Link>
      ),
    },
    {
      key: 'Status',
      name: 'Status',
      styles: { root: { textAlign: 'center' } },
      minWidth: 130,
      maxWidth: 130,
      onRender: (item: VisitSummary) => <VisitStatusIcon status={item.status} horizontal />,
    },
    {
      key: 'Service',
      name: 'Service',
      minWidth: 90,
      maxWidth: 140,
      onRender: (item: VisitSummary) => item.serviceOffering?.shortName,
    },
    {
      key: 'Provider',
      name: 'Provider',
      minWidth: 180,
      maxWidth: 180,
      onRender: ({ doctor }: VisitSummary) =>
        doctor ? <Link href={`${ROUTES.providers}/${doctor.providerId}`} target="_blank">{`${doctor?.prefix} ${doctor?.firstName} ${doctor?.lastName}`}</Link> : '',
    },
    {
      key: 'Assistant',
      name: 'Assistant',
      minWidth: 180,
      maxWidth: 180,
      onRender: ({ assistant }: VisitSummary) =>
        assistant ? <Link href={`${ROUTES.providers}/${assistant.providerId}`} target="_blank">{`${assistant?.firstName} ${assistant?.lastName}`}</Link> : '',
    },
  ];

  return (
    <CollapsibleSection title={title} id="visitHistory">
      {visits.length === 0 && <MessageBar>No visits found for the patient.</MessageBar>}
      {visits.length > 0 && (
        <ShimmeredDetailsList
          items={visits}
          columns={columns}
          compact={true}
          selectionMode={0}
          layoutMode={1}
          shimmerLines={10}
          onRenderDetailsHeader={(headerProps, defaultRender) => {
            if (!headerProps || !defaultRender) {
              return null;
            }
            return defaultRender({
              ...headerProps,
              styles: {
                root: {
                  padding: 0,
                  height: 24,
                  lineHeight: 24,
                  selectors: { '.ms-DetailsHeader': { padding: 0 }, '.ms-DetailsHeader-cell': { height: 0 } },
                },
              },
            });
          }}
        />
      )}
    </CollapsibleSection>
  );
}
